import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const InstantFilter = ({ onChange, value = [] }) => {
  const { t } = useTranslation()
  const options = [
    { label: t('Instantáneo'), value: 'true' },
    { label: t('No instantáneo'), value: 'false' },
  ]

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <div>
      <ComboBox
        value={value}
        label={t('Modo de transacción')}
        fullWidth
        handleChange={handleChange}
        menuItems={options}
      />
    </div>
  )
}

export default InstantFilter
